<template>
  <vs-tabs
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
    id="profile-tabs"
    :key="isSmallerScreen"
  >
    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Geral' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-general />
      </div>
    </vs-tab>

    <!-- CHANGE PASSWORD -->
    <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? 'Mudar Senha' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-change-password />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
  import UserSettingsGeneral from "./UserSettingsGeneral.vue"
  import UserSettingsChangePassword from "./UserSettingsChangePassword.vue"

  import moduleUser from "@/store/user/moduleUser"

  export default {
    components: {
      UserSettingsGeneral,
      UserSettingsChangePassword
    },
    computed: {
      isSmallerScreen() {
        return this.$store.state.windowWidth < 768
      }
    },
    created() {
      if (!moduleUser.isRegistered) {
        this.$store.registerModule('user', moduleUser)
        moduleUser.isRegistered = true
      }
      this.$store.dispatch("user/fetch")
    }
  }
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
